import React, { useState } from 'react';
import './AddressTypeForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import ToggleSwitch from '../../../shared/ToggleSwitch';

function AddressTypeForm({ initial, onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [canDeliver, setCanDeliver] = useState(initial ? initial.can_deliver !== false : true);
  const [error, setError] = useState('');

  const validate = () => {
    if (!name.trim()) return 'Name is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({ name: name.trim(), can_deliver: canDeliver });
  };

  return (
    <form className="address-type-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div>
        <label>Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Ship To"
          style={{ width: 260 }}
        />
      </div>

      <div style={{ marginTop: 12 }}>
        <ToggleSwitch checked={canDeliver} onChange={setCanDeliver} label="Delivery address in the customer portal" />
        <div style={{ fontSize: 12, color: '#5a6b85', marginTop: 4, maxWidth: 420 }}>
          Customers can choose an address of this type as the delivery address when they order from the portal.
        </div>
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default AddressTypeForm;
